import resolveResponse from 'contentful-resolve-response'

import {ThemeProvider, Box, Grid} from '@primer/react-brand'

import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {ContentfulSubnav} from '@github-ui/swp-core/components/contentful/ContentfulSubnav'
import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'
import {FootnotesProvider} from '@github-ui/swp-core/components/contentful/FootnotesContext'

import {toPayload} from '../../../../lib/types/payload'
import {toBrandPage} from '../../../../brand/lib/types/contentful'
import type {GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

import {HeroSection} from './HeroSection'
import {PillarsSection} from './PillarsSection'
import {FeaturesSection} from './FeaturesSection'
import {PricingSection} from './PricingSection'
import {ResourcesSection} from './ResourcesSection'
import {FaqSection} from './FaqSection'

import {PlanTypeContextProvider} from '../_context/PlanTypeContext'

export default function FeaturesCopilotAiCodeEditorIndex() {
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())
  const contentfulResponse = resolveResponse(contentfulRawJsonResponse)
  const page = toBrandPage(contentfulResponse)

  const {template} = page.fields
  const {subnav} = template.fields
  const {
    featuresCopilotAiCodeEditorHeroSection,
    featuresCopilotAiCodeEditorPillarsSection,
    featuresCopilotAiCodeEditorFeaturesSection,
    featuresCopilotAiCodeEditorPricingSection,
    featuresCopilotAiCodeEditorResourcesSection,
    featuresCopilotAiCodeEditorFaqSection,
  } = page.ids as {
    featuresCopilotAiCodeEditorHeroSection: GenericSectionWithIds
    featuresCopilotAiCodeEditorPillarsSection: GenericSectionWithIds
    featuresCopilotAiCodeEditorFeaturesSection: GenericSectionWithIds
    featuresCopilotAiCodeEditorPricingSection: GenericSectionWithIds
    featuresCopilotAiCodeEditorResourcesSection: GenericSectionWithIds
    featuresCopilotAiCodeEditorFaqSection: GenericSectionWithIds
  }

  return (
    <FootnotesProvider>
      <PlanTypeContextProvider>
        <ThemeProvider colorMode="dark" className="lp-Copilot position-relative">
          <Box className="lp-SubNav-spacer" />

          {subnav ? (
            <ContentfulSubnav component={subnav} className="lp-Hero-subnav lp-Hero-subnav--highContrast" />
          ) : null}

          {featuresCopilotAiCodeEditorHeroSection ? (
            <HeroSection contentfulContent={featuresCopilotAiCodeEditorHeroSection} />
          ) : null}

          {featuresCopilotAiCodeEditorPillarsSection ? (
            <PillarsSection contentfulContent={featuresCopilotAiCodeEditorPillarsSection} />
          ) : null}

          {featuresCopilotAiCodeEditorFeaturesSection ? (
            <FeaturesSection contentfulContent={featuresCopilotAiCodeEditorFeaturesSection} />
          ) : null}

          {featuresCopilotAiCodeEditorPricingSection ? (
            <PricingSection contentfulContent={featuresCopilotAiCodeEditorPricingSection} />
          ) : null}

          {featuresCopilotAiCodeEditorResourcesSection ? (
            <ResourcesSection contentfulContent={featuresCopilotAiCodeEditorResourcesSection} />
          ) : null}

          {featuresCopilotAiCodeEditorFaqSection ? (
            <FaqSection contentfulContent={featuresCopilotAiCodeEditorFaqSection} />
          ) : null}

          <Grid>
            <Grid.Column span={12}>
              <ContentfulInlineFootnotesList />
            </Grid.Column>
          </Grid>
        </ThemeProvider>
      </PlanTypeContextProvider>
    </FootnotesProvider>
  )
}

try{ FeaturesCopilotAiCodeEditorIndex.displayName ||= 'FeaturesCopilotAiCodeEditorIndex' } catch {}